;((Slider, $) => {

  let $dom = {};

  let isDirectionNext = true;

  const isMobile = () => window.innerWidth < 1021;

  const cacheDom = () => {
    $dom.window = $(window);
    $dom.productSlider = $('.product-slider');
    $dom.blogMenuSlider = $('.js-blog-slider'); 
  };
  
  const initMobileProductSlider = () => {
    if(!$dom.productSlider.hasClass('slick-initialized')) {
      $dom.productSlider.slick({
        arrows: false,
        dots: true,
        dotsClass: 'pdp__image-gallery-thumbnails',
        appendDots: '.product-images',
        prevArrow: `<span class="arrow-left"></span>`,
        nextArrow: `<span class="arrow-right"></span>`,
        customPaging(slider, i) {
          const slide = $(slider.$slides[i]).find('.slide');
          const thumb = slide.data('thumb');
          const playIcon = slide.data('play-icon');
          if (playIcon) return `<button type="button" class="pdp__image-gallery-thumbnail pdp__image-gallery-thumbnail--video"><img class="pdp__image-gallery-thumbnail-image" src="${thumb}"/><img class="pdp__image-gallery-thumbnail-play" src="${playIcon}" alt="play button"></button>`;
          else return `<button type="button" class="pdp__image-gallery-thumbnail"><img src="${thumb}"/></button>`;
        }
      });
    }
  };

  const destroyProductSlider = () => {
    if($dom.productSlider.hasClass('slick-initialized')) {
      if($dom.productSlider.hasClass('filtered')) {
        $dom.productSlider.slick('slickUnfilter');
        $dom.productSlider.removeClass('filtered');
      }
      $dom.productSlider.slick('unslick');
    }
  }

  const next = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.8 13.4" data-role="none" class="slick-arrow slick-next" width="16" height="16" style="display: block;"><path d="M7.8 1.1c0 .1 0 .2-.1.3L2.4 6.7 7.7 12c.1 0 .1.2.1.3 0 .1 0 .2-.1.3l-.7.6c-.1.1-.2.1-.3.1s-.2 0-.3-.1L.1 7C0 6.9 0 6.8 0 6.7c0-.1 0-.2.1-.3L6.3.2c.2-.2.3-.2.4-.2s.2 0 .3.1l.7.7c.1.1.1.2.1.3z"></path></svg>
`;
  const prev = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.8 13.4" data-role="none" class="slick-arrow slick-prev" width="16" height="16" style="display: block;"><path d="M7.8 1.1c0 .1 0 .2-.1.3L2.4 6.7 7.7 12c.1 0 .1.2.1.3 0 .1 0 .2-.1.3l-.7.6c-.1.1-.2.1-.3.1s-.2 0-.3-.1L.1 7C0 6.9 0 6.8 0 6.7c0-.1 0-.2.1-.3L6.3.2c.2-.2.3-.2.4-.2s.2 0 .3.1l.7.7c.1.1.1.2.1.3z"></path></svg>
`;

  const initInnerMenuSlider = () => {
    $dom.blogMenuSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      variableWidth: true,
      infinite: false,
      prevArrow: prev,
      nextArrow: next
    })
  }

  const setupProductSliderListener = () => {
    $(window).on('resize', () => {
      if (!$dom.productSlider.hasClass('slick-initialized')) {
        initMobileProductSlider();
        Slider.filterMobileProductSlider();
      } else {
        if(!$dom.productSlider.hasClass('filtered')) Slider.filterMobileProductSlider();
      }
    });
  }

  const bindUIActions = () => {

    $dom.blogMenuSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      const slidesToScroll = slick.options.slidesToScroll;
      const slideLength = slick.$slides.length - slidesToScroll;

      if (nextSlide >= slideLength || nextSlide == 0) {
        isDirectionNext = !isDirectionNext;
      }

      if (isDirectionNext) {
        $('.slick-next').addClass('is-active');
        $('.slick-prev').removeClass('is-active');
      } else {
        $('.slick-next').removeClass('is-active');
        $('.slick-prev').addClass('is-active');
      }
    });

    setupProductSliderListener();
  };

  Slider.init = () => {
    cacheDom();
    bindUIActions();
    initMobileProductSlider();
    initInnerMenuSlider();
  };

  Slider.filterMobileProductSlider = (variantAlt) => {
    if(!$dom.productSlider.hasClass('slick-initialized')) return;

    let variant;
    if(variantAlt) {
      // destroy slider, then re-slick and filter only current variant image(s) + lifestyle
      destroyProductSlider();
      initMobileProductSlider();
      variant = variantAlt;
    } else {
      // initial filter
      variant = $('.js-variant-select option:selected').data('variant-alt');
    }

    // filter slider items only for products that are not stack bundles
    if($dom.productSlider.closest('.pdp__product.stack-bundle').length == 0) {
      $dom.productSlider.slick("slickFilter", (index, element) => {
        const slideVariantAlt = $(element).find("[data-variant-alt]").attr("data-variant-alt");
        return (slideVariantAlt === variant || slideVariantAlt === "lifestyle");
      });
      $dom.productSlider.addClass('filtered');
      $dom.productSlider.slick("slickGoTo", 0, true);
    }
  }

})(window.Slider = window.Slider || {}, jQuery);